<nav class="custom-navbar">
    <div class="d-flex flex-row justify-content-between align-items-center px-2 py-2 w-100 h-100 gap-sm-1">
        <div class="d-flex align-items-center h-100 gap-2 gap-sm-2 gap-lg-5">
            <button class="bg-transparent rounded-2 border-0 h-100" (click)="router.navigate(['dashboard','inicio'])">
                <img style="max-height: 100%; width: auto;" [src]="logoUrl" alt="Logo" />
            </button>

            @if (client_environment.features.hasClients && userCanSeeClientes && client_environment.appName !==
            'gruesnadal') {
            <div class="d-flex align-items-center">
                <button (click)="showClientDialog = true" class="btn btn-client bg-secondary"
                    [ngStyle]="{'max-width': navigationService.isMobileOrTablet() ? '7rem' : ''}"
                    style="border: none; outline: none; cursor: pointer; color: white; overflow: hidden;">
                    <i class="pi pi-user"></i>
                    <span *ngIf="clients.selected">
                        {{ (clients.selected.razon_social || clients.selected.nombre) + ' ' +
                        (clients.selected.apellido_1 ? (clients.selected.apellido_1 + ' ' + clients.selected.apellido_2)
                        : '' )}}
                    </span>
                </button>
            </div>
            }
        </div>

        <h1 *ngIf="!navigationService.isMobileOrTablet()" class="text-white fs-4 badge">
            {{ dashboardService.headerTitle ?? 'Locatec' | titlecase }}
        </h1>

        <div class="d-flex gap-sm-2 gap-lg-5 align-items-center">
            @if(client_environment.appName === 'agrogestSIEX') {
            <p-menu #helpMenu [model]="helpMenuItems" [popup]="true" appendTo="body"></p-menu>
            <p-button ngClass="btn-help-navbar" [label]="!navigationService.isMobileOrTablet() ? 'Ayuda' : ''"
                [ngStyle]="{ 'background-color': '#db4061 !important;'}"
                icon="pi pi-question-circle"
                (onClick)="helpMenu.toggle($event)">
            </p-button>
            }

            <div class="d-flex align-items-center gap-2">
                <span *ngIf="!navigationService.isMobileOrTablet()" class="text-lg text-white">{{currentUser.nombre}}
                    {{currentUser.apellidos}}</span>
                <div class="d-flex justify-content-center">
                    <p-menu #menu [model]="menuItems" [popup]="true" appendTo="body"></p-menu>

                    <button *ngIf="!navigationService.isMobileOrTablet()"
                        class="btn-menu d-flex justify-center align-items-center align-content-center"
                        (click)="menu.toggle($event)">
                        <i style="font-size: 1.5rem;" class="pi pi-bars"></i>
                    </button>

                    <button *ngIf="navigationService.isMobileOrTablet()"
                        class="btn-menu d-flex justify-center align-items-center align-content-center"
                        (click)="toogleSidebar()">
                        <i *ngIf="!navigationService.sidebarCollapsed()" style="font-size: 1.5rem;"
                            class="pi pi-bars"></i>
                        <i *ngIf="navigationService.sidebarCollapsed()" style="font-size: 1.5rem;"
                            class="pi pi-times"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</nav>

@if (client_environment.features.hasClients && userCanSeeClientes && client_environment.appName !== 'gruesnadal') {
<p-dialog [header]="'Seleccionar ' + client_environment.features.clientesName" [style]="{width: '40vw' ,height: '60vh'}"
    [(visible)]="showClientDialog" [breakpoints]="{'1199px': '75vw', '575px': '90vw'}" (onShow)="scrollToTop()">

    <label>Seleccionar {{ client_environment.features.clientesName }}</label>

    <p-select [options]="clients.filtered" [(ngModel)]="clients.selected"
        [placeholder]="'Seleccionar ' + client_environment.features.clientesName" optionValue="value"
        optionLabel="label" [filter]="true" [showClear]="true" (onChange)="updateClient()">
    </p-select>

    <div class="w-100 d-flex justify-content-center">
        <button class="btn btn-primary" style="margin-top: 2rem" (click)="showClientDialog = false">Aceptar</button>
    </div>
</p-dialog>
}


<p-dialog header="Mi perfil" [breakpoints]="{'1199px': '75vw', '575px': '90vw'}"
    [(visible)]="showClientProfile">

    @if(!isComunero) {
    <div class="w-100">
        <div class="d-flex justify-content-between">
            <p> {{currentUser.email || 'Usuario sin email'}} </p>
            <div class="d-flex justify-content-center">
                <p-button severity="info" label="Firma" icon="pi pi-pencil" iconPos="left"
                    (click)="showSignature()"></p-button>
            </div>
        </div>

        <app-form-builder [model]="currentUser" [undoEnabled]="false" [distributionColumns]="2" [fields]="formFields"
            (formChanges)="formChanges($event)">
        </app-form-builder>

        <app-form-builder [model]="currentUser" [undoEnabled]="false" [distributionColumns]="2" [fields]="formFields2"
            (formChanges)="formChanges($event)">
        </app-form-builder>

        <div class="alert alert-light text-secondary p-2 mt-3 small">
            <p *ngIf="client_environment.appName">Los cambios tendrán efecto cuando vuelva a iniciar sesión.</p>
            <p style="color: red;">{{client_environment.appName === 'agrogestSIEX' ? subscriptionStateMessage : '8 MB de 1 GB usados.'}}</p>
        </div>

        <div *ngIf="showUsuariosFirma" class="w-100 mb-4 d-flex justify-content-center">
            <p class="lead">Firma</p>
            <div class="canvas-wrap">
                <app-signature #sp (onEndEvent)="drawComplete(signaturePadElement)"></app-signature>
            </div>
            <button data-html2canvas-ignore="true" class="p-0 m-0 btn btn-link btn-link-tight"
                (click)="clearSigPad(signaturePadElement)">Borrar</button>
        </div>
    </div>
    }

    @else {
    <div class="w-100">
        <p>{{ (currentClient.email | titlecase) ?? 'Usuario sin email' }}</p>
        <hr>
        <app-form-builder [model]="currentClient" [undoEnabled]="false" [distributionColumns]="2" [fields]="formClient"
            (formChanges)="formChanges($event)">
        </app-form-builder>
    </div>
    }

    <ng-template #footer>
        <div class="dlg-actions">
            <button class="btn btn-dark mx-2" (click)="showClientProfile = false;">Volver</button>
            <button *ngIf="!actualizando()" class="btn btn-primary mx-2">
                <i class="fa fa-pencil" aria-hidden="true"></i> Actualizar
            </button>
            <button *ngIf="actualizando()" class="btn btn-primary mx-2" disabled>
                <div class="spinner-border spinner-border-sm" role="status"></div> Actualizando...
            </button>
        </div>
    </ng-template>
</p-dialog>

<app-wizard-modal [(visible)]="displayWizard"></app-wizard-modal>